<template>

</template>

<script>

    import customButton from 'components/button/customButton.vue'
    import responsiveImage from 'components/image/responsiveImage.vue'

    export default {
        components: {
            customButton,
            responsiveImage
        },
        data() {
            return {};
        },
        mounted() {

        }
    }

</script>

<style rel="stylesheet/scss" lang="scss" type="text/css">
    .break {
        flex-basis: 100%;
        width: 0px;
        height: 0px;
        overflow: hidden;
    }
</style>
